import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LoginConsentModal from "./components/LoginConsentModal";
import Landing from "./pages/Landing";
import Translator from "./pages/Translator";
import AuthCallback from "./pages/AuthCallback";
import BillingSuccess from "./pages/BillingSuccess";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import ProtectedRoute from "./components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id during render (not in useEffect) to prevent
  // race conditions with the global AuthProvider.
  if (location.hash?.includes("session_id=")) {
    return (
      <>
        <Header />
        <AuthCallback />
      </>
    );
  }
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <Translator />
            </ProtectedRoute>
          }
        />
        <Route
          path="/billing/success"
          element={
            <ProtectedRoute>
              <BillingSuccess />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route path="/legal/:doc" element={<Legal />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Footer />
      <LoginConsentModal />
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <div className="App min-h-screen flex flex-col">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: "#0A0A0A",
                color: "#F4F4F0",
                border: "2px solid #0A0A0A",
                borderRadius: 0,
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: "12px",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
              },
            }}
          />
        </div>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
